export const webtrekkValuesAvailable = () => window && window.wt && window.wt.eid;
